import { render } from "./IconSummary.vue?vue&type=template&id=652cda85&ts=true"
import script from "./IconSummary.vue?vue&type=script&lang=ts"
export * from "./IconSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__